import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import classNames from 'classnames';

const Note = (props) => {
  const labelClass = classNames(
    'controls',
    {
      alert: props.includeDefaultNoteStyle,
    },
  );
  return (
    <div
      className={labelClass}
      dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(props.label)}` }}
    />
  );
};

Note.defaultProps = {
  includeDefaultNoteStyle: true,
};

Note.propTypes = {
  includeDefaultNoteStyle: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

export default Note;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/Note.jsx